import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editAtmCompany = ( {data, atmCompanyId} : {data: IPostEditAtmCompany | {}, atmCompanyId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/AtmCompanies/UpdateAtmCompany/${atmCompanyId}`, data);
};

type QueryFnType = typeof editAtmCompany;

type UseEditAtmCompanyOptions = {
  data: IPostEditAtmCompany | {};
  atmCompanyId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditAtmCompany = ({ config }: UseEditAtmCompanyOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Εταιρίας.`, 500);
            console.error('Couldnt edit AtmCompany', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmCompanies"])
            addNotification('Η Εταιρία Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editAtmCompany,
    })
}